import { render, staticRenderFns } from "./HoverPopover.vue?vue&type=template&id=dcdf74e6&"
import script from "./HoverPopover.vue?vue&type=script&lang=js&"
export * from "./HoverPopover.vue?vue&type=script&lang=js&"
import style0 from "./HoverPopover.vue?vue&type=style&index=0&id=dcdf74e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports